import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import LoadingModal from '../../../../components/atoms/LoadingModal';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';
import { ScreenTitle } from '../../../../components/atoms';
import MessageModal from '../../../../components/molecules/MessageModal';
import { Strings } from '../../../../shared/constants/Constants';

const SubTopicScreen = ({
  userId,
  sessionToken,
  loading,
  enqueueSnackbar,
  subtopicList = [],
  isNetConnected,
  showTopicList,
  purchaseStatus,
  history,

  getListOfSubTopics = () => {
  },
  getQuestionByTopicId = () => {
  },
}) => {
  let { query: { sub_topic_id = ' ' } = {} } = qs.parseUrl(
    window.location.href,
  );

  // const [topics, updateTopics] = useState([]);
  const [showModal, updateModal] = useState(false);
  const [showPurchaseModal, updatePurchaseModal] = useState(false);
  const [modalTitle, updateTitle] = useState('');
  const [message, updateMessage] = useState('');

  useEffect(() => {
    fetchSubTopics();
  }, []);

  const fetchSubTopics = () => {

    const subTopicRequestBody = {
      userId: userId,
      sessionToken: sessionToken,
      categoryId: sub_topic_id,
    };
    getListOfSubTopics(
      subTopicRequestBody,
      () => {
      },
      (message, type) => {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
    );
  };

  const goToSubTopicQuestion = (topic, currentIndex) => {

    if (topic.question_count > 0) {
      const questionBody = {
        userId: userId,
        sessionToken: sessionToken,
        categoryId: topic.id,
      };
      if (
        purchaseStatus == false &&
        parseInt(subtopicList[currentIndex].hidden_question_count) >= 5
      ) {
        updatePurchaseModal(true);
        // alert("hidennnn");
        //this.hidePurchaseGameModal(false);
      } else {
        // getQuestionByTopicId(questionBody, currentIndex, (message, type) => {
        //   enqueueSnackbar(message, {
        //     variant: type,
        //     autoHideDuration: 3000,
        //     anchorOrigin: {
        //       vertical: "bottom",
        //       horizontal: "left",
        //     },
        //   });
        // });
        history.push(
          `${ROUTE_CONSTANTS.TOPIC_QUESTIONS}?sub_topic_id=${topic.id}&question_index=${currentIndex}`,
        );
      }
    } else if (topic.question_count <= 0) {
      updateTitle(topic.cateName);
      updateMessage('No questions available.');
      updateModal(true);
    }
    // }
  };
  const hidePurchaseModal = () => {
    updatePurchaseModal(false);
  };

  const renderSubTopics = (subtopicList) => {
    if (subtopicList.length > 0) {
      return (
        <>
          <div className='card-summary-container video_grids'>
            <div className='row'>
              {subtopicList.map((item, index) => {
                let { cateName, question_count, id } = item;
                return (
                  <div
                    className='col6'
                    key={id}
                    onClick={() => {
                      goToSubTopicQuestion(item, index);
                    }}
                  >
                    <div className='card-summary list_videos'>
                      <h6 style={{ fontWeight: 'bold' }}>{cateName}</h6>
                      <span>Contains {question_count} Quiz Questions</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      );
    } else {
      return (
        <div className='no_result'>{'No Sub Topics available.'}</div>
      );
    }
  };

  return (
    <>
      <ScreenTitle title='Topics' subTitle='Sub Topics'/>
      {showModal && (
        <MessageModal
          title={modalTitle}
          message={message}
          color={'#fff'}
          callback={() => {
            updateTitle('');
            updateMessage('');
            updateModal(false);
          }}
        />
      )}
      {showPurchaseModal && (
        <MessageModal
          title={Strings.purchaseTitle}
          message={Strings.purchaseMessage}
          callback={hidePurchaseModal}
          render={() => {
            return (
              <button
                style={{
                  background: '#fff',
                  border: '1.25px solid #7ebf41',
                  color: '#7ebf41',
                  padding: '.65rem 2rem',
                  borderRadius: '5px',
                  fontWeight: 'bolder',
                  marginTop: '1rem',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  history.replace(ROUTE_CONSTANTS.PURCHASE_P2P);
                }}
              >
                Okay
              </button>
            );
          }}
        />
      )}
      {
        loading ? (
          <LoadingModal isVisible={loading}/>
        ) : (
          // show_question ? (
          //   <QuestionScreen id={sub_topic_id} index={quesIndex} />
          // ) : (
          renderSubTopics(subtopicList)
        )
        //)
      }
    </>
  );
};

export default withRouter(withSnackbar(SubTopicScreen));
